module.exports = __webpack_public_path__ + "img/hr-sand-3.128da992.png";